import { ColumnSetting } from "lib/types/models";

export type TransactionColumn = "buyer" | "supplier" | "amount" | "date";

/**
 * What the column picker offers on the transactions table. The buyer column is locked.
 * Each file also brings its own descriptive columns, which are appended after these and
 * never offered: they vary with the data on the page, so they aren't a stable setting.
 */
export const TRANSACTION_COLUMNS: ColumnSetting<TransactionColumn>[] = [
  { title: "Buyer", field: "buyer", disabled: true },
  { title: "Supplier", field: "supplier" },
  { title: "Transaction value", field: "amount" },
  { title: "Date", field: "date" },
];

export const TRANSACTION_COLUMN_FIELDS = TRANSACTION_COLUMNS.map((c) => c.field) as [
  TransactionColumn,
  ...TransactionColumn[],
];

/** The column the picker won't let you turn off, so a shared link shouldn't either. */
export const LOCKED_TRANSACTION_COLUMN: TransactionColumn = "buyer";
